module.exports = __webpack_public_path__ + "media/images/android-chrome-512x512-110d39838d187f8faa34279eca860f2d.png";